// 判断环境,是否安卓,苹果,微信,APP内外
// https://wiki.didapinche.com/index.php?title=User-Agent_定义
import bsGetEnv from "../BsGetEnv";
export function isXCX(){
  let {inWechat, isAlipay} = bsGetEnv;
  return new Promise((resolve, reject) => {
    if(inWechat && window.wx && wx.miniProgram){
      // 微信
      wx.miniProgram.getEnv(async function(res) {
        if (res.miniprogram) {
            // 小程序内
            resolve({isWx: true, isAli: false});
        }
        resolve({isWx: false, isAli: false});
      })   
    }else if(isAlipay && window.my){
      // 支付宝
      window.my.getEnv((res)=>{
        if (res.miniprogram) {
            // 在支付宝小程序中打开
            resolve({isAli: true,isWx: false});
        }
        resolve({isAli: false,isWx: false});
      })
    }else{
      resolve({isAli: false,isWx: false});
    }
  })
}
const isxcx = isXCX();
export default function(){
  return isxcx;
}